import { Box, BoxProps } from "@chakra-ui/react"
import "./index.css"

interface RainbowSpinnerProps extends BoxProps {}

const RainbowSpinner: React.FC<RainbowSpinnerProps> = props => {
  return (
    <Box position="absolute" {...props}>
      <div className="sk-chase">
        <div className="sk-chase-dot"></div>
        <div className="sk-chase-dot"></div>
        <div className="sk-chase-dot"></div>
        <div className="sk-chase-dot"></div>
        <div className="sk-chase-dot"></div>
        <div className="sk-chase-dot"></div>
      </div>
    </Box>
  )
}

export default RainbowSpinner
